const APPLICATION_STEPS = {
  questionnaire: "questionnaire",
  requirements: "requirements",
  application_rate: "application_rate",
  code_challenge: "code_challenge",
  video_interview: "video_interview",
  profile_completion: "profile_completion",
  role_application: "role_application",
  sign_up: "sign_up",
};

export default APPLICATION_STEPS;
